import React from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";

import { Controller, useForm } from "react-hook-form";
const UpdateModal = ({ toggleModal, kelas }) => {
  const { register, control } = useForm({
    defaultValues: {
      mahasiswa: kelas.nama,
      waktu: kelas.waktu,
      nilai: kelas.nilai,
      keterangan: kelas.keterangan,
      status: {
        value: kelas.status,
        label: kelas.status === 0 ? "Tidak Hadir" : "Tepat Waktu",
      },
    },
  });
  const statusOption = [
    {
      value: 0,
      label: "Tidak Hadir",
    },
    {
      value: 1,
      label: "Tepat Waktu",
    },
  ];

  const closeModal = () => {
    toggleModal(false);
  };
  return (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Ubah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Nama</label>
          <input
            type="text"
            {...register("mahasiswa")}
            className="form-control"
          />
        </div>

        <div className="form-group mb-3">
          <label className="form-label">Nilai</label>
          <input type="time" {...register("waktu")} className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Waktu Hadir</label>
          <input type="text" {...register("nilai")} className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Keterangan</label>
          <textarea {...register("keterangan")} className="form-control" />
        </div>
        <div className="form-group mb-3">
          <label className="form-label">Status</label>
          <Controller
            control={control}
            name="status"
            render={({ field }) => (
              <Select value={field.value} options={statusOption} {...field} />
            )}
          />
        </div>

        <button className="btn w-100 btn-success" onClick={closeModal}>
          Ubah
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateModal;
